var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestsDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "-26 0 480 480",
    width: "480pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "697acfa0-7973-4628-bfe3-ff29b70732f4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006df0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7f0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b740817e-9bed-4d2d-bb8c-fe2d516e53d7",
    gradientUnits: "userSpaceOnUse",
    x1: 215.613918,
    x2: 195.149918,
    xlinkHref: "#697acfa0-7973-4628-bfe3-ff29b70732f4",
    y1: 480.184,
    y2: -8.392
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a47a8868-52bd-49ea-a787-4297e74b1099",
    gradientUnits: "userSpaceOnUse",
    x1: 298.813918,
    x2: 278.349918,
    xlinkHref: "#697acfa0-7973-4628-bfe3-ff29b70732f4",
    y1: 476.696,
    y2: -11.872
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "72ac769b-e73e-4c56-b589-a252db93c05a",
    gradientUnits: "userSpaceOnUse",
    x1: 216.613918,
    x2: 196.149918,
    xlinkHref: "#697acfa0-7973-4628-bfe3-ff29b70732f4",
    y1: 480.136,
    y2: -8.432
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m421.652344 418.609375-159.726563-252.929687v-117.679688h16c4.417969 0 8-3.582031 8-8v-32c0-4.417969-3.582031-8-8-8h-128c-4.417969 0-8 3.582031-8 8v32c0 4.417969 3.582031 8 8 8h16v117.679688l-159.71875 252.921874c-7.804687 12.320313-8.28125 27.910157-1.25 40.6875 7.035157 12.777344 20.464844 20.714844 35.050781 20.710938h347.839844c14.582032.003906 28.011719-7.929688 35.046875-20.703125 7.035157-12.777344 6.558594-28.367187-1.242187-40.6875zm-263.726563-402.609375h112v16h-112zm22.769531 156.273438c.800782-1.28125 1.226563-2.761719 1.230469-4.273438v-120h64v120c.003907 1.511719.429688 2.992188 1.230469 4.273438l73.089844 115.726562h-212.640625zm228.199219 279.292968c-4.175781 7.71875-12.273437 12.503906-21.046875 12.433594h-347.839844c-8.753906 0-16.8125-4.761719-21.03125-12.429688-4.21875-7.667968-3.929687-17.027343.757813-24.417968l77.765625-123.152344h232.851562l77.773438 123.199219c4.738281 7.359375 5.03125 16.726562.769531 24.367187zm0 0",
    fill: "url(#b740817e-9bed-4d2d-bb8c-fe2d516e53d7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m293.925781 320c-22.089843 0-40 17.910156-40 40s17.910157 40 40 40c22.089844 0 40-17.910156 40-40-.027343-22.082031-17.917969-39.972656-40-40zm0 64c-13.253906 0-24-10.746094-24-24s10.746094-24 24-24c13.253907 0 24 10.746094 24 24s-10.746093 24-24 24zm0 0",
    fill: "url(#a47a8868-52bd-49ea-a787-4297e74b1099)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m213.925781 384c-17.671875 0-32 14.328125-32 32s14.328125 32 32 32 32-14.328125 32-32-14.328125-32-32-32zm0 48c-8.835937 0-16-7.164062-16-16s7.164063-16 16-16c8.835938 0 16 7.164062 16 16s-7.164062 16-16 16zm0 0",
    fill: "url(#72ac769b-e73e-4c56-b589-a252db93c05a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestsDark);
export default __webpack_public_path__ + "static/media/TestsDark.77387419.svg";
export { ForwardRef as ReactComponent };